/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_References_DescriptionInputs */



/**
* | output |
* | --- |
* | "Link spaces and files to this project. Linked resources are available as context in all project chats." |
*
* @param {Project_References_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_references_description = /** @type {((inputs?: Project_References_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_References_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verknüpfe Spaces und Dateien mit diesem Projekt. Verknüpfte Ressourcen stehen als Kontext in allen Projekt-Chats zur Verfügung.")
	return /** @type {LocalizedString} */ ("Link spaces and files to this project. Linked resources are available as context in all project chats.")
});